module.exports = __webpack_public_path__ + "img/jiangpai-3.3886b05c.svg";